/* pantallas-alumno (B): EL BLOQUE DEL ESQUELETO DEL PANEL.

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   El esqueleto del Panel (I1) vive en `components/skeletons.js` y su bloque (`BloqueDelPanel`) no se
   exporta: este es el MISMO bloque (el degradado de la casa, #181818 a #232323, con su pulso) para que
   cada pantalla del alumno arme el esqueleto que copia SU acomodo nuevo. Las tarjetas del esqueleto
   usan la caja de la tarjeta del Panel (`TARJETA` de `components/panel/anatomia.js`). */
import React from 'react';

export const DEGRADADO_DEL_ESQUELETO = Object.freeze({ backgroundImage: 'linear-gradient(90deg, #181818, #232323)' });

export default function BloqueEsqueleto({ className = '', testid }) {
  return <div aria-hidden="true" data-testid={testid} className={`animate-pulse rounded-md ${className}`.trim()} style={DEGRADADO_DEL_ESQUELETO} />;
}
